export default "__VITE_ASSET__80785c89__"